import { useTranslation } from 'react-i18next';

export default function ServicesSection() {
  const { t } = useTranslation('common');

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const services = [
    {
      icon: 'ri-server-line',
      title: t('services.itInfrastructure.title'),
      description: t('services.itInfrastructure.description'),
      gradient: 'from-[#4d9c71] to-[#4d9c71]'
    },
    {
      icon: 'ri-rocket-line',
      title: t('services.digitalisation.title'),
      description: t('services.digitalisation.description'),
      gradient: 'from-[#4d9c71] to-[#4d9c71]'
    },
    {
      icon: 'ri-cloud-line',
      title: t('services.backup.title'),
      description: t('services.backup.description'),
      gradient: 'from-[#4d9c71] to-[#4d9c71]'
    },
    {
      icon: 'ri-eye-line',
      title: t('services.surveillance.title'),
      description: t('services.surveillance.description'),
      gradient: 'from-[#4d9c71] to-[#4d9c71]'
    },
    {
      icon: 'ri-shield-check-line',
      title: t('services.cybersecurity.title'),
      description: t('services.cybersecurity.description'),
      gradient: 'from-[#4d9c71] to-[#4d9c71]'
    },
    {
      icon: 'ri-settings-3-line',
      title: t('services.managedServices.title'),
      description: t('services.managedServices.description'),
      gradient: 'from-[#4d9c71] to-[#4d9c71]'
    },
    {
      icon: 'ri-task-line',
      title: t('services.projectManagement.title'),
      description: t('services.projectManagement.description'),
      gradient: 'from-[#4d9c71] to-[#4d9c71]'
    },
    {
      icon: 'ri-user-star-line',
      title: t('services.cisoService.title'),
      description: t('services.cisoService.description'),
      gradient: 'from-[#4d9c71] to-[#4d9c71]'
    }
  ];

  return (
    <section id="services" className="py-24 lg:py-32 relative">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: 'url(https://static.readdy.ai/image/c07ed6529feea951012003251bff6ba4/78a627228f114a68e878a20237e5938e.jpeg)' }}></div>
      <div className="absolute inset-0 bg-black/70"></div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="text-sm font-semibold text-[#4d9c71] uppercase tracking-wider mb-4 whitespace-nowrap">
            {t('services.sectionTitle')}
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            {t('services.title')}
          </h2>
          <p className="text-lg text-gray-200 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-[#F5F7FA] rounded-3xl p-10 hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer"
            >
              {/* Icon */}
              <div className={`w-16 h-16 rounded-full bg-gradient-to-r ${service.gradient} flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed mb-6">
                {service.description}
              </p>

              {/* Learn More Link */}
              <button 
                onClick={scrollToContact}
                className="inline-flex items-center text-[#4d9c71] font-medium hover:gap-2 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                {t('services.learnMore')}
                <i className="ri-arrow-right-line ml-1"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
